import { FacebookAnalytics as r } from "../../../../js/analytics/facebook/index.js";
import { useState as a, useRef as f, useEffect as u } from "react";
function l(e) {
  const [s, n] = a(!1), t = f(!1);
  return u(() => {
    if (!e) {
      t.current && r.revokeConsent(), t.current = !1;
      return;
    }
    let o = !0;
    return t.current = !0, r.grantConsent(), r.loadPixel(e).then(() => {
      o && n(!0);
    }), () => {
      o = !1, n(!1);
    };
  }, [e]), {
    isReady: s
  };
}
export {
  l as useFacebookPixel
};
//# sourceMappingURL=useFacebookPixel.js.map
